import React from 'react';
import PropTypes from 'prop-types';

import {onDestinationChange, onPageUpdate} from '../../services/targeting';
import {MesoAdsContext} from '../MesoAdsContext/MesoAdsContext';
import {needAdsRefresh} from "../../utils/need-ads-refresh";

export class MesoAdsContextWithSearchParams extends MesoAdsContext {
    constructor(props) {
        super(props);
        /* istanbul ignore next */
        if (this.state && this.state.isBrowser) {
            this.state.prevSearch = window.location.search;
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps){
        if (nextProps.gaiaId !== this.props.gaiaId) {
            onDestinationChange({gaiaId: nextProps.gaiaId, clearPrevTargeting: true});
            this.setState({gaiaId: nextProps.gaiaId });
        }
    }

    componentDidUpdate(prevProps) {
        const {pathname: prevPathname} = prevProps.searchParams || {};
        const {params, prevParams, pathname} = this.props.searchParams || {};

        if (this.state.isBrowser) {
            if (pathname !== prevPathname) {
                needAdsRefresh(params, prevParams) && onPageUpdate();
            }

            if (window.location.search !== this.state.prevSearch) {
                onPageUpdate();
                this.setState({prevSearch: window.location.search});
            }
        }
    }
}

MesoAdsContextWithSearchParams.defaultProps = {
    searchParams: {}
};

MesoAdsContextWithSearchParams.propTypes = {
    ...MesoAdsContext.propTypes,
    // Represent data from search filters
    searchParams: PropTypes.shape({
        pathname: PropTypes.string,
        params: PropTypes.shape({
            q: PropTypes.string,
            zoom: PropTypes.number,
            neLat: PropTypes.number,
            swLat: PropTypes.number,
            swLong: PropTypes.number
        }),
        prevParams: PropTypes.shape({
            q: PropTypes.string,
            zoom: PropTypes.number,
            neLat: PropTypes.number,
            swLat: PropTypes.number,
            swLong: PropTypes.number
        })

    }).isRequired
};

